import React, { useContext, useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import { getActiveXList } from '../../../Service/getActiveX';
import { AuthContext } from '../../../Context/AuthContext';

function EscoAutocomplete({ codTpActiveX, onChange, value, label, placeholder, multiple, disabled }) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [valores, setValores] = useState("");
    const [initial, setInitial] = useState([]);
    const { tokenExpiration, getAccessToken } = useContext(AuthContext);


    const ObtenerSeleccionados = async () => {
        try {
            const token = await getAccessToken();
            setLoading(true);
            const data = await getActiveXList(token, codTpActiveX);
            setOptions(data);

            const descriptions = value.split(';').map((desc) => desc.trim()); // Divide la cadena en un array de descripciones

            const initialOptions = data.filter((opt) => descriptions.includes(opt.Descripcion.trim())); // Verifica si cada descripción está incluida
            setValores(value);

            setInitial(initialOptions);

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }



        
    };


    useEffect(() => {
        if (codTpActiveX) {
            ObtenerSeleccionados();
        }
    }, [codTpActiveX]);


    const handleAutocompleteChange = (event, newValue) => {
        onChange(event, newValue);
        setInitial(newValue);
    };

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    return (
        <Autocomplete
            multiple={multiple}
            options={options}
            disableCloseOnSelect
            onChange={handleAutocompleteChange}
            getOptionLabel={(option) => option.Descripcion}
            //getOptionSelected={(option, value) => option.Descripcion === value.Descripcion}
            //getOptionSelected={(option, value) => option.Codigo === value.Codigo}
            isOptionEqualToValue={(option, value) => option.Codigo === value.Codigo}
            //value={initial}
            value={initial}
            style={{ width: 300 }}
            renderOption={(props, option, { selected }) => (
                <li {...props}>
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 2 }}
                        checked={selected}
                    />
                    {option.Descripcion}
                </li>
            )}
            disabled={disabled}
            style={{ width: 500, maxHeight: 200, overflowY: 'auto' }}
            renderInput={(params) => (
                <TextField {...params} label={label} placeholder={placeholder} />
            )}
        />
    );
}

export default EscoAutocomplete;
